import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";

const SalesReturnReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const[cust, setCust] = useState(null)
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , 'months').format(),
    toDate :  moment().format()
  })
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.sales_lines)
    setRowData(e.row)
    setOpen(true)
  }
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "billNo",
    headerName: "Bill No",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Outlet Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amt",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "cgst",
    headerName: "CGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sgst",
    headerName: "SGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  // {
  //   field: "igst",
  //   headerName: "IGST",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "cess",
  //   headerName: "Cess",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "dis",
  //   headerName: "Dis",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      return (
        <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon />
        </IconButton>
      );
    },
  },
]

const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.docdate).format("DD-MM-YYYY"),
  billNo : val.docno,
  party : val.fullname,
  amt : val.amount,
  cess : parseFloat(val.cess_amt).toFixed(0),
  dis : val.dis_amt || 0,
  tot: parseFloat(val.amount).toFixed(0),
  cgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sales_lines:val.sales_lines,
  tot_amt: val.amount,
  documentNo:val.docno,
  documentDate:moment(val.docdate).format("DD-MM-YYYY"),
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Product name" },
  // { id:3, label: "Doc No" },
  // { id:4, label: "Doc date" },
  { id:3 , label:"MRP"},
  { id:4, label:"Gst Amnt"},
  { id:5 , label:"Gst Per %"},
  { id:6 , label:"Qty"},
  { id:7 , label:"Rate"},
  {id:8, label: 'Total'}
];
const tableBodyData = _.map(salesLines, (val,idx) => ({
  id:idx,
  sNo:idx+1,
  name:val.pro_name,
  docNo:val.docno,
  docDate:moment(val.docdate).format('DD-MM-YYYY'),
  Mrp:parseFloat(val.mrp).toFixed(0),
  gstAmnt:parseFloat(val.gst_amt).toFixed(0),
  gstPer:val.gst_per,
  Qty:val.qty,
  Rate:parseFloat(val.rate).toFixed(0),
  totalAmount : parseFloat( val.qty * val.rate ).toFixed(0)
}))
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleSalesReturn(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : 0
  }
  axios.post('/v1/reports/sales/return', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  return (
    <Fragment>
      <Helmet><title>Sales Return Reports</title></Helmet>
      <Typography variant="h6">Sales Return Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname:"All" } , ...supplier]}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  );
};

export default memo(SalesReturnReport);
